package com.havn.app.features.followups.domain

data class AiFollowUpInput(
    val visitorName: String,
    val propertyAddress: String,
    val visitorInterest: String,
    val notes: String,
    val leadStatus: String,
    val agentName: String,
    val messageType: String,
    val tone: String,
    val languageCode: String,
    val languageName: String,
    val languageNativeName: String
)

data class AiFollowUpDraft(
    val smsDraft: String,
    val emailSubject: String,
    val emailDraft: String
)

interface AiFollowUpService {
    suspend fun generateDraft(input: AiFollowUpInput): Result<AiFollowUpDraft>
}
